import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material";

@Injectable()
export class SnackBarService {
    constructor(private snackBar: MatSnackBar) { }

    openSnackBar(message: string, action?: string) {
        this.snackBar.open(message, action || "DISMISS", {
            duration: 3000,
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/core/snack-bar.service.ts